export interface FollowUpOption {
  value: string;
  label: string;
  color?: string;
}

// 意向程度选项
export const INTENT_OPTIONS: FollowUpOption[] = [
  { value: '高意向', label: '高意向', color: 'red' },
  { value: '中等意向', label: '中等意向', color: 'orange' },
  { value: '低意向', label: '低意向', color: 'blue' },
  { value: '无意向', label: '无意向', color: 'gray' },
];

// 跟进状态选项
export const STATUS_OPTIONS: FollowUpOption[] = [
  { value: '跟进中', label: '跟进中', color: 'blue' },
  { value: '已报价', label: '已报价', color: 'orange' },
  { value: '谈判中', label: '谈判中', color: 'purple' },
  { value: '已成交', label: '已成交', color: 'green' },
  { value: '已流失', label: '已流失', color: 'red' },
  { value: '待跟进', label: '待跟进', color: 'gray' },
];

// 客户等级选项
export const CLIENT_TYPE_OPTIONS: FollowUpOption[] = [
  { value: '跨境电商', label: '跨境电商', color: 'blue' },
  { value: '国内电商', label: '国内电商', color: 'green' },
  { value: '国内工厂', label: '国内工厂', color: 'purple' },
  { value: '线下零售', label: '线下零售', color: 'purple' },
  { value: '同行', label: '同行', color: 'purple' },
];
